export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  property: {
    p: '24px 12px',
    pb: 0,
    display: 'flex',
    alignItems: 'center',
    color: 'text.white',
    fontWeight: 500,
    fontSize: '14px',
  },
  avatar: {
    border: '1px solid #6E6E6E',
    mr: 1,
  },
  list: {
    py: 3,
    px: 1.5,
  },
  listItemButton: {
    alignItems: 'center',
    '&.Mui-selected': {
      backgroundColor: 'text.grey.blue_1',
      borderRadius: 42,
      '& .MuiListItemText-root, .MuiListItemIcon-root': {
        color: 'text.white',
      },
      '& .MuiListItemIcon-root svg': {
        fill: 'red',
      },
    },
  },
  withIcon: {
    p: 1,
  },
  noIcon: {
    p: '8px 12px',
  },
  listItem: {
    mb: 1.2,
  },
  listItemIcon: {
    minWidth: 24,
    height: 24,
    alignItems: 'center',
    color: 'text.grey.blue_2',
    px: 1,
  },
  text: {
    color: 'text.grey.blue_2',
    '& .MuiTypography-root': {
      typography: 'body2',
    },
  },
  backButton: {
    color: 'text.grey.blue_2',
    mt: 'auto',
    p: '24px 12px',
    '&:hover p': {
      color: 'text.grey.blue_2',
      backgroundColor: 'transparent',
    },
  },
};
